import React, { useEffect } from 'react';
import AuthService from '../services/AuthService';

export default function SilentRefreshPage(props) {

    useEffect(() => {
        async function signInAsync() {
            var authService = await AuthService.getInstance();
            authService.signinSilentCallback()
                .catch(error => {
                    alert('Error in silent refresh', error);
                });
        }
        signInAsync();
    });

    return null;
}